import React from "react";

import { ServerCmsConstantsBreadcrumb, ThemeChooserBlock } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Clickable } from "../Clickables";
import { Svg } from "../Svg";
import { getThemeClass } from "../ThemedModule";

import styles from "./Breadcrumbs.module.scss";

export const Breadcrumbs = ({
    value,
    theme,
}: {
    value: ServerCmsConstantsBreadcrumb[];
    theme?: ThemeChooserBlock | null;
}) => {
    const links = [...value];
    const last = links.pop();

    return (
        <nav
            aria-label="Breadcrumbs"
            className={concatClassNames([styles.root, getThemeClass(theme)])}
        >
            <ol className={styles.list}>
                <Svg name="caret" aria-hidden />
                {links.map((breadcrumb) => (
                    <li key={breadcrumb.url}>
                        <Clickable href={breadcrumb.url}>
                            {breadcrumb.label}
                        </Clickable>
                        <span role="separator" aria-orientation="vertical">
                            /
                        </span>
                    </li>
                ))}

                {last && (
                    <li>
                        <Clickable aria-current="page" href={last.url}>
                            {last.label}
                        </Clickable>
                    </li>
                )}
            </ol>
        </nav>
    );
};
